import script from "./OrderHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderHistory.vue?vue&type=script&setup=true&lang=js"

import "./OrderHistory.vue?vue&type=style&index=0&id=543d14fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-543d14fc"]])

export default __exports__